export const origins = [
  { key: 'app', name: 'Aplicação' },
  { key: 'portal', name: 'Portal de agendamentos' },
  { key: 'console', name: 'Console' },
  { key: 'hub', name: 'Hub' },
  { key: 'hook', name: 'Integração' },
  { key: 'integration', name: 'Integração externa' },
  { key: 'public', name: 'Área pública' },
  { key: 'worker', name: 'Rotina automática' },
  { key: 'system', name: 'Rotina automática' },
];

export function get(key) {
  return origins.find(item => item.key === key);
}

export function getName(key) {
  const origin = get(key);
  return origin ? origin.name : key;
}

export default origins;
